/*
 * @Descripttion: Pincode lookup API
 * @Date: 2024-08-10
 */
import axios from 'axios'

// 根据pincode查询城市
const lookupPincode = pincode =>
  axios.get('/api/v1/pincode/lookup', { params: { pincode } }).then(res => res.data)

export default { lookupPincode }
